"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
exports.preloadReady = exports.preloadAll = exports.Capture = exports.LoadableMap = void 0;
var react_1 = __importStar(require("react"));
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var CaptureContext = react_1.createContext(undefined);
CaptureContext.displayName = 'Capture';
var isWebpackReady = function isWebpackReady(getModuleIds) {
  return typeof __webpack_modules__ === 'object' && getModuleIds().every(function (moduleId) {
    return typeof moduleId !== 'undefined' && typeof __webpack_modules__[moduleId] !== 'undefined';
  });
};
var load = function load(loader) {
  var state = {
    loading: true,
    loaded: undefined,
    error: undefined
  };
  state.promise = new Promise(function (resolve, reject) {
    return __awaiter(void 0, void 0, void 0, function () {
      var loaded, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4 /*yield*/, loader()];
          case 1:
            loaded = _a.sent();
            state.loading = false;
            state.loaded = loaded;
            resolve(loaded);
            return [3 /*break*/, 3];
          case 2:
            e_1 = _a.sent();
            state.loading = false;
            state.error = e_1;
            reject(e_1);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  });

  return state;
};
var loadMap = function loadMap(obj) {
  var e_2, _a;
  var state = {
    loading: false,
    loaded: {},
    error: undefined
  };
  var promises = [];
  try {
    var _loop_1 = function _loop_1(key) {
      var result = load(obj[key]);
      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else state.loading = true;
      promises.push(result.promise);
      (function () {
        return __awaiter(void 0, void 0, void 0, function () {
          var _a, _b, e_3;
          return __generator(this, function (_c) {
            switch (_c.label) {
              case 0:
                _c.trys.push([0, 2,, 3]);
                _a = state.loaded;
                _b = key;
                return [4 /*yield*/, result.promise];
              case 1:
                _a[_b] = _c.sent();
                return [3 /*break*/, 3];
              case 2:
                e_3 = _c.sent();
                state.error = e_3;
                return [3 /*break*/, 3];
              case 3:
                return [2 /*return*/];
            }
          });
        });
      })();
    };

    try {
      for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var key = _c.value;
        _loop_1(key);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  } catch (err) {
    state.error = err;
  }
  state.promise = new Promise(function (resolve, reject) {
    return __awaiter(void 0, void 0, void 0, function () {
      var res, e_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4 /*yield*/, Promise.all(promises)];
          case 1:
            res = _a.sent();
            state.loading = false;
            resolve(res);
            return [3 /*break*/, 3];
          case 2:
            e_4 = _a.sent();
            state.loading = false;
            reject(e_4);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  });

  return state;
};
var resolve = function resolve(obj) {
  var _a;
  return ((_a = obj) === null || _a === void 0 ? void 0 : _a.__esModule) ? obj["default"] : obj;
};
var render = function render(loaded, props) {
  return react_1["default"].createElement(resolve(loaded), props);
};
var createLoadableComponent = function createLoadableComponent(loadFn, options) {
  if (!options.loading) throw new Error('react-loadable requires a `loading` component');
  var opts = __assign({
    delay: 200,
    render: render
  }, options);
  var res;
  var init = function init() {
    if (!res) res = loadFn(opts.loader);
    return res.promise;
  };
  ALL_INITIALIZERS.push(init);
  if (typeof opts.webpack === 'function') READY_INITIALIZERS.push(function () {
    if (isWebpackReady(opts.webpack)) return init();
  });
  var LoadableComponent = /** @class */function (_super) {
    __extends(LoadableComponent, _super);
    function LoadableComponent(props) {
      var _this = _super.call(this, props) || this;
      init();
      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      _this._loadModule();
      return _this;
    }
    LoadableComponent.prototype.componentDidMount = function () {
      this._mounted = true;
    };
    LoadableComponent.prototype.componentWillUnmount = function () {
      this._mounted = false;
      this._clearTimeouts();
    };
    LoadableComponent.prototype.render = function () {
      return this.state.loading || this.state.error ? react_1["default"].createElement(opts.loading, {
        isLoading: this.state.loading,
        pastDelay: this.state.pastDelay,
        timedOut: this.state.timedOut,
        error: this.state.error,
        retry: this._retry
      }) : this.state.loaded || null ? opts.render(this.state.loaded, this.props.props) : null;
    };
    LoadableComponent.prototype._retry = function () {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _super.prototype.setState.call(this, {
                error: undefined,
                loading: true,
                timedOut: false
              });
              res = loadFn(opts.loader);
              return [4 /*yield*/, this._loadModule()];
            case 1:
              _a.sent();
              return [2 /*return*/];
          }
        });
      });
    };

    LoadableComponent.prototype._setStateWithMountCheck = function (newState) {
      if (!this._mounted) return;
      _super.prototype.setState.call(this, newState);
    };
    LoadableComponent.prototype._loadModule = function () {
      return __awaiter(this, void 0, void 0, function () {
        var _a, _b, moduleName, _c;
        var e_5, _d;
        var _this = this;
        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              if (this.props.report && Array.isArray(opts.modules)) try {
                for (_a = __values(opts.modules), _b = _a.next(); !_b.done; _b = _a.next()) {
                  moduleName = _b.value;
                  this.props.report(moduleName);
                }
              } catch (e_5_1) {
                e_5 = {
                  error: e_5_1
                };
              } finally {
                try {
                  if (_b && !_b.done && (_d = _a["return"])) _d.call(_a);
                } finally {
                  if (e_5) throw e_5.error;
                }
              }
              if (!res.loading) return [2 /*return*/];
              if (typeof opts.delay === 'number') {
                if (opts.delay === 0) {
                  if (this._mounted) _super.prototype.setState.call(this, {
                    pastDelay: true
                  });else this.state.pastDelay = true;
                } else {
                  this._delay = setTimeout(function () {
                    _this._setStateWithMountCheck({
                      pastDelay: true
                    });
                  }, opts.delay);
                }
              }
              if (typeof opts.timeout === 'number') {
                this._timeout = setTimeout(function () {
                  _this._setStateWithMountCheck({
                    timedOut: true
                  });
                }, opts.timeout);
              }
              _e.label = 1;
            case 1:
              _e.trys.push([1, 3, 4, 5]);
              return [4 /*yield*/, res.promise];
            case 2:
              _e.sent();
              return [3 /*break*/, 5];
            case 3:
              _c = _e.sent();
              return [3 /*break*/, 5];
            case 4:
              this._clearTimeouts();
              this._setStateWithMountCheck({
                error: res.error,
                loaded: res.loaded,
                loading: res.loading
              });
              return [7 /*endfinally*/];
            case 5:
              return [2 /*return*/];
          }
        });
      });
    };

    LoadableComponent.prototype._clearTimeouts = function () {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };
    LoadableComponent.displayName = 'LoadableComponent';
    return LoadableComponent;
  }(react_1["default"].Component);
  var ContextWrapper = function ContextWrapper(props) {
    return react_1["default"].createElement(CaptureContext.Consumer, null, function (report) {
      return react_1["default"].createElement(LoadableComponent, {
        props: props,
        report: report
      });
    });
  };
  ContextWrapper.preload = init;
  ContextWrapper.displayName = 'CaptureContextWrapper';
  return ContextWrapper;
};
exports["default"] = function (opts) {
  return createLoadableComponent(load, opts);
};
var LoadableMap = function LoadableMap(opts) {
  if (typeof opts.render !== 'function') throw new Error('LoadableMap requires a `render(loaded, props)` function');
  return createLoadableComponent(loadMap, opts);
};
exports.LoadableMap = LoadableMap;
var Capture = function Capture(_a) {
  var children = _a.children,
    report = _a.report;
  return react_1["default"].createElement(CaptureContext.Provider, {
    value: report
  }, children);
};
exports.Capture = Capture;
exports.Capture.displayName = 'Capture';
var flushInitializers = function flushInitializers(initializers) {
  return __awaiter(void 0, void 0, void 0, function () {
    var promises;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          promises = [];
          while (initializers.length) promises.push(initializers.pop()());
          return [4 /*yield*/, Promise.all(promises)];
        case 1:
          _a.sent();
          if (initializers.length) return [2 /*return*/, flushInitializers(initializers)];
          return [2 /*return*/];
      }
    });
  });
};

var preloadAll = function preloadAll() {
  return flushInitializers(ALL_INITIALIZERS);
};
exports.preloadAll = preloadAll;
var preloadReady = function preloadReady() {
  return flushInitializers(READY_INITIALIZERS);
};
exports.preloadReady = preloadReady;